<div #thumbnail class="pdf-viewer "></div>